exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".general-quotation-info[data-v-aac5c996]{line-height:1.4}.general-quotation-info strong[data-v-aac5c996]{text-transform:none}", ""]);

// exports
